<template>
  <v-layout row wrap>
    <v-flex xs12 md6>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="course-info pa-3 elevation-2">
            <v-alert v-model="alert.status" dismissible :type="alert.type">{{ alert.message }}</v-alert>
            <template v-if="!loading.course">
              <p>CURSO: <strong>{{ course.name }}</strong></p>
              <p>NOME COMPLETO: <strong>{{ course.full_name }}</strong></p>
              <p>CÓDIGO/SIGLA: <strong>{{ course.code }}</strong></p>
              <p class="mb-0">TIPO: <strong>{{ course.type | courseType }}</strong></p>
            </template>
            <template v-else>
              <h2 class="text-xs-center font-weight-light py-3">CARREGANDO CURSO!</h2>
            </template>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="grids pa-3 elevation-2">
            <h3 class="mb-2">GRADES CURRICULARES</h3>
            <hr />
            <ul class="pl-0">
              <li v-show="!loading.grids" v-for="grid in grids" :key="grid.id" @click="getModules(grid)" class="grid-item py-2 pl-2">{{ grid.name }}<span @click.stop="deleteGrid(grid.id)" class="del-icon"><i class="fas fa-trash-alt mr-2" style="float: right;"></i></span></li>
              <template>
                <li v-if="loading.grids" class="grid-item py-3 pl-2 text-xs-center">CARREGANDO GRADES CURRICULARES.</li>
                <li v-else-if="!loading.grids && grids.length == 0" class="grid-item py-3 pl-2 text-xs-center">NÃO HÁ GRADES CADASTRADAS!</li>
              </template>
            </ul>
            <hr />
            <v-form ref="gridForm" v-model="gridValidation" lazy-validation>
              <v-layout row wrap class="mt-1">
                <v-flex xs8>
                  <v-text-field v-model="gridData.name" @keyup.enter="createGrid" :counter="26" label="NOME, EX: V2019, V2020" :rules="gridNameRules" required box/>
                </v-flex>
                <v-flex xs4>
                  <v-btn style="width: 100%;" class="ma-0 mt-2" @click="createGrid()" large outline>INSERIR</v-btn>
                </v-flex>
                <v-text-field v-show="false"></v-text-field>
              </v-layout>
            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md6>
      <div class="modules pa-3 elevation-2">
        <template v-if="!modules">
          <h2 class="text-xs-center font-weight-light py-3">SELECIONE UMA GRADE!</h2>
        </template>
        <template v-else>
          <h3 class="mb-2">MODULOS DA GRADE <span>"{{ currentGrid.name }}"</span> <span v-if="currentGrid.closed"> (FECHADA)</span></h3>
          <hr />
          <template v-if="modules && modules.length == 0">
            <h2 class="text-xs-center font-weight-light py-3">NÃO HÁ MODULOS CADASTRADOS!</h2>
          </template>
          <template v-else>
            <ul class="pl-0">
              <li class="module-item py-2 pl-2" v-for="(mod, ind) in modules" :key="mod.id">{{ ind+1 }} - {{ mod.name }} <span v-if="!currentGrid.closed"><i class="fas fa-edit edit-module-grid pl-2" @click="currentModuleGrid = mod; editingModuleGrid = true;"></i> <i class="fas fa-trash-alt delete-module-grid pl-2" @click="deleteModuleGrid(mod.id)"></i></span></li>
            </ul>
          </template>
          <hr />
          <v-form v-if="!currentGrid.closed" ref="moduleForm" v-model="moduleValidation" lazy-validation>
            <v-layout row wrap class="mt-1">
              <v-flex xs12 class="pb-0">
                <v-text-field v-model="moduleData.name" @keyup.enter="createModule()" :counter="240" label="NOME, EX: Introdução, Analise" :rules="moduleNameRules" required box/>
              </v-flex>
              <v-flex xs6 class="pt-0">
                <v-btn style="width: 100%;" class="ma-0" @click="createModule()" outline>INSERIR</v-btn>
              </v-flex>
              <v-flex xs6 class="pt-0">
                <v-btn style="width: 100%;" color="error" class="ma-0" @click="closeGrid()" outline>FECHAR GRADE</v-btn>
              </v-flex>
              <v-text-field v-show="false"></v-text-field>
            </v-layout>
          </v-form>
        </template>

        <v-dialog v-model="editingModuleGrid" width="400">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>EDIÇÃO DE SALA.</v-card-title>
            <v-card-text>
              <v-form v-model="editModuleValidation" ref="editRoomForm" lazy-validation>
                <v-text-field v-model="currentModuleGrid.name" :counter="240" label="NOME, EX: Introdução, Analise" :rules="moduleNameRules" required box/>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" flat @click="getModules(currentGrid); editingModuleGrid = false;">SAIR</v-btn>
              <v-btn color="primary" flat @click="saveModuleGrid()">PROSSEGUIR</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'course',
  data() {
    return {
      course: {},
      grids: {},
      modules: false,
      currentGrid: false,
      currentModuleGrid: false,
      editModuleValidation: true,
      gridValidation: true,
      moduleValidation: true,
      gridData: { name: '' },
      moduleData: { name: '' },
      editingModuleGrid: false,
      gridNameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 4) || 'NOME NÃO PODE TER MENOS DE 04 CARACTERES!',
        v => (v && v.length <= 26) || 'NOME NÃO PODE TER MAIS DE 26 CARACTERES!',
      ],
      moduleNameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 6) || 'NOME NÃO PODE TER MENOS DE 06 CARACTERES!',
        v => (v && v.length <= 240) || 'NOME NÃO PODE TER MAIS DE 240 CARACTERES!',
      ],
      loading: {
        course: true,
        grids: true,
        modules: false
      },
      alert: {
        message: '',
        type: 'success',
        status: false
      },
    }
  },
  methods: {
    getCourse() {
      this.loading.course = true
      this.$http(`courses/${this.$route.params.id}`).then(data => {
        this.course = data.data
        this.getGrids()
        this.loading.course = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    getGrids() {
      this.loading.grids = true
      this.$http.get(`/grids/all/${this.course.id}`).then(data => {
        this.grids = data.data
        this.loading.grids = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    getModules(grid) {
      this.loading.modules = true
      this.$http.get(`modules/${grid.id}`).then(data => {
        this.modules = data.data
        this.currentGrid = grid
        this.currentGrid.closed = Number(this.currentGrid.closed) // Transforma em Numero/Boolean! //
        this.loading.modules = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    createGrid() {
      if (this.$refs.gridForm.validate()) {
        this.$http.post(`grids/${this.course.id}`, { name: this.gridData.name, code: `${this.course.code}${this.gridData.name}` }).then(data => {
          this.getGrids()
          this.$refs.gridForm.reset()
        }).catch(err => {
          this.alert.message = err
          this.alert.type = 'error'
          this.alert.status = true
        })
      }
    },
    createModule() {
      if (this.$refs.moduleForm.validate()) {
        this.$http.post(`modules/${this.course.id}/${this.currentGrid.id}`, {
          name: this.moduleData.name,
          code: `${this.course.id}-${this.currentGrid.id}-${this.moduleData.name}`
        }).then(data => {
          this.modules = data.data
          this.getModules(this.currentGrid)
          this.$refs.moduleForm.reset()
        }).catch(err => {
          this.alert.message = err
          this.alert.type = 'error'
          this.alert.status = true
        })
      }
    },
    closeGrid() {
      this.$http.put(`grids/${this.currentGrid.id}`, {}).then(data => {
        this.currentGrid.closed = true
        this.alert.message = 'GRADE FECHADA!'
        this.alert.type = 'success'
        this.alert.status = true
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    deleteGrid(gridId) {
      this.$http.delete(`grids/${gridId}`, {}).then(data => {
        this.alert.message = 'GRADE E MODULOS EXCLUIDOS!'
        this.alert.type = 'success'
        this.alert.status = true
        this.getGrids()
        this.currentGrid = false
        this.modules = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    deleteModuleGrid(id) {
      this.$http.delete(`/courseGrid/${id}`).then(data => {
        this.getModules(this.currentGrid)
      }).catch(err => {

      })
    },
    saveModuleGrid() {
      this.$http.put(`/courseGrid/${this.currentModuleGrid.id}`, {
        name: this.currentModuleGrid.name,
        code: `${this.course.id}-${this.currentGrid.id}-${this.currentModuleGrid.name}`
      }).then(data => {
        this.getModules(this.currentGrid)
        this.editingModuleGrid = false
      }).catch(err => {

      })
    }
  },
  created() {
    this.getCourse()
  }
}
</script>

<style scoped>
  .course-info, .grids, .modules {
    background-color: #fff;
  }
  .grid-item, .module-item {
    list-style-type: none;
    cursor: pointer;
  }
  .grid-item:hover, .module-item:hover {
    background-color: rgba(0,0,0,.1);
  }
  .del-icon {
    display: block;
    position: relative;
    bottom: 18px;
  }
  .del-icon:hover {
    color: #c4161c;
  }
  .edit-module-grid:hover {
    color: #0076FF;
  }
  .delete-module-grid:hover {
    color: #c4161c;
  }
</style>
